export class UserAgent {
    private readonly userAgent: string;

    constructor(userAgent: string) {
        this.userAgent = userAgent;
    }

    public isBot(): boolean {
        return (
            this.isGoogleBot() ||
            this.isGoogleLighthouseBot() ||
            this.isGoogleAPIsBot() ||
            this.isGoogleAdsBot() ||
            this.isGoogleAdSenseBot() ||
            this.isWebPageTestBot() ||
            this.isDuckDuckGoBot() ||
            this.isYahooBot() ||
            this.isBingBot() ||
            this.isDatadogSyntheticsBot() ||
            this.isHeadlessChrome() ||
            this.isBaiduSpider() ||
            this.isScreamingFrogBot() ||
            this.isSEBot() ||
            this.isCrawler()
        );
    }

    public isGoogleBot(): boolean {
        return /googlebot/i.test(this.userAgent);
    }

    public isGoogleLighthouseBot(): boolean {
        return /(google page speed insights)|(chrome-lighthouse)/i.test(this.userAgent);
    }

    public isGoogleAPIsBot(): boolean {
        return /apis-google/i.test(this.userAgent);
    }

    public isGoogleAdSenseBot(): boolean {
        return /mediapartners-google/i.test(this.userAgent);
    }

    public isGoogleAdsBot(): boolean {
        return /adsbot-google/i.test(this.userAgent);
    }

    public isWebPageTestBot(): boolean {
        return /ptst\//i.test(this.userAgent);
    }

    public isBingBot(): boolean {
        return /bingbot/i.test(this.userAgent);
    }

    public isDuckDuckGoBot(): boolean {
        return /duckduckbot/i.test(this.userAgent);
    }

    public isYahooBot(): boolean {
        return /yahoo!/i.test(this.userAgent);
    }

    public isDatadogSyntheticsBot(): boolean {
        return /Datadog\/Synthetics|DatadogSynthetics/i.test(this.userAgent);
    }

    public isHeadlessChrome(): boolean {
        return /HeadlessChrome/i.test(this.userAgent);
    }

    public isBaiduSpider(): boolean {
        return /Baiduspider/i.test(this.userAgent);
    }

    public isScreamingFrogBot(): boolean {
        return /Screaming Frog SEO Spider/i.test(this.userAgent);
    }

    public isSEBot(): boolean {
        return /SEBot/i.test(this.userAgent);
    }

    public isCrawler(): boolean {
        return /crawler|spider|externalhit|MJ12bot|SemrushBot/i.test(this.userAgent);
    }

    public static current() {
        return new UserAgent(window.navigator.userAgent);
    }
}
